import SpektrixAPI from "../utils/SpektrixAPI";
import SpektrixSession from "./SpektrixSession";

class SpektrixLogin extends HTMLElement {
    constructor() {
        super();

        this.api = new SpektrixAPI();
        this.session = new SpektrixSession();
        this.domain = this.getAttribute("spektrix-domain");
        this.errors = this.querySelector("[login-error]");
        this.password_message = this.querySelector("[password-message]");
    }

    connectedCallback() {
        this.querySelector("#spektrix-login-form").addEventListener(
            "submit",
            (event) => this.handleLogin(event),
        );
        this.querySelector("[reset-password]").addEventListener("click", () =>
            this.handleResetPassword(),
        );
    }

    async handleLogin(event) {
        event.preventDefault();

        const email = this.querySelector("#spektrixLoginEmail").value;
        const password = this.querySelector("#spektrixLoginPassword").value;

        this.session.login({ email, password }, false);
    }

    async handleResetPassword() {
        this.password_message.textContent = "";
        this.errors.textContent = "";
        const email_is_valid = this.querySelector(
            "#spektrixLoginEmail",
        ).checkValidity();

        if (!email_is_valid) {
            this.errors.textContent =
                "Please provide a valid email address and try again.";
            return;
        }

        const email = this.querySelector("#spektrixLoginEmail").value;
        const password_request = await this.api.request(
            `/customer/forgot-password?emailAddress=${email}&domain=${this.domain}`,
            "POST",
        );

        this.password_message.textContent =
            "A reset link has been sent to your email address.";
    }
}

customElements.define("spektrix-login", SpektrixLogin);
